"use client";

import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { ROUTES } from "@/constants/routes";
import { usePriorityTickets } from "@/hooks/automatic-streak";
import { Zap } from "lucide-react";
import Link from "next/link";

/**
 * Header pill showing the unconsumed priority-ticket balance. Gold matches the
 * Arena vocabulary (medal-gold) since tickets are earned in paid Arena
 * competitions. Hidden while loading or when the balance is 0.
 */
export const PriorityTicketsHeaderChip = () => {
  const { totalTickets, isLoading, isError } = usePriorityTickets();

  // Hidden on error too: the chip must not render a false 0-like state.
  if (isLoading || isError || totalTickets === 0) return null;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Link
          href={ROUTES.PROFILE}
          aria-label={`${totalTickets} priority ticket${totalTickets > 1 ? "s" : ""}`}
          className="flex h-8 shrink-0 items-center gap-1.5 rounded-button border border-medal-gold/35 bg-medal-gold/10 px-3 text-xs font-semibold text-medal-gold transition-colors hover:bg-medal-gold/20 focus:outline-none focus:ring-2 focus:ring-medal-gold/60"
        >
          <Zap className="h-3.5 w-3.5" fill="currentColor" aria-hidden />
          <span className="tabular-nums">{totalTickets}</span>
        </Link>
      </TooltipTrigger>
      <TooltipContent className="max-w-[240px]">
        Your priority tickets. Spend them to move up in the autopilot queue.
      </TooltipContent>
    </Tooltip>
  );
};
